export default "__VITE_PUBLIC_ASSET__55c6f4d9__"